import Requests from "@/services/Requests";

const state = {
  admins: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  allAdmins: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
  createStatus: "unitiliazed", // unitiliazed, loading, success, error
  updateStatus: "unitiliazed", // unitiliazed, loading, success, error
  deleteStatus: "unitiliazed", // unitiliazed, loading, success, error
  adminById: {
    status: "unitiliazed", // unitiliazed, loading, success, error
    data: [],
    count: 0,
  },
};
const getters = {
  /**
   * Returns a subset of admins based on the given page number.
   *
   * @param {Object} state - The Vuex state object.
   * @param {number} [page=0] - The page number to filter admins by. Defaults to 0.
   * @return {Array} An array of admins filtered by the given page number. If page is 0, returns all admins.
   */
  getAdmins:
    (state) =>
    (page = 0) =>
      page === 0
        ? state.admins.data
        : state.admins.data
            .filter(
              (value, index, self) =>
                index === self.findIndex((t) => t.id === value.id)
            )
            .filter((d) => d.page === page),
  getAllAdmins: (state) => state.allAdmins.data,
  getAdminStatus: (state) => state.admins.status,
  getAdminCount: (state) => state.admins.count,
  getAdminPage: (state) => state.admins.page,
  getAdminPages: (state) => Math.ceil(state.admins.count / 10),
  getAdminsLoading: (state) => state.admins.status === "loading",
  getAdminById: (state) => (id) =>
    state.adminById.data.find((d) => d.id === id) || {},
};
const mutations = {
  /**
   * Updates the status of the admin in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the admin.
   */
  SET_ADMIN_STATUS(state, payload) {
    console.log(state.admins, "status: ", payload);
    state.admins.status = payload;
  },
  /**
   * Sets the admins and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of admins.
   * @param {number} payload.count - The total count of admins.
   */
  SET_ADMINS(state, payload) {
    state.admins.data = payload.items;
    console.log("SET_ADMINS", payload);
    state.admins.count = payload.count;
  },
  /**
   * Sets the admins and count in the state based on the payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the items and count.
   * @param {Array} payload.items - The array of admins.
   * @param {number} payload.count - The total count of admins.
   */
  SET_ALL_ADMINS(state, payload) {
    console.log("SET_ALL_ADMINS", payload);
    state.allAdmins.data = payload.items;
    state.allAdmins.count = payload.count;
  },
  /**
   * Updates the status of the update admin in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the admin.
   */
  SET_UPDATE_ADMIN_STATUS(state, payload) {
    state.updateStatus = payload;
  },
  /**
   * Updates an admin object in the state with new information.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The updated admin object.
   * @return {void}
   */
  SET_UPDATE_ADMIN(state, payload) {
    const index = state.admins.data.findIndex((d) => d.id === payload.id);
    const admin = state.admins.data[index];
    state.admins.data[index] = { ...admin, ...payload };
  },
  SET_CREATE_ADMIN_STATUS(state, payload) {
    state.createStatus = payload;
  },
  /**
   * Adds a new admin to the list of admins in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The admin object to be added.
   * @return {void}
   */
  SET_CREATE_ADMIN(state, payload) {
    state.admins.data.push(payload);
  },
  /**
   * Updates the status of the delete admin in the state.
   *
   * @param {Object} state - The Vuex state object.
   * @param {"unitiliazed" | "loading" | "success" | "error"} payload - The new status of the admin.
   */
  SET_DELETE_ADMIN_STATUS(state, payload) {
    state.deleteStatus = payload;
  },
  /**
   * Removes an admin from the state based on the provided payload.
   *
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the admin ID to be deleted.
   * @param {number} payload.id - The ID of the admin to be deleted.
   * @return {void}
   */
  SET_DELETE_ADMIN(state, payload) {
    state.admins.data = state.admins.data.filter((d) => d.id !== payload.id);
  },
  SET_ADMIN_BY_ID_STATUS(state, payload) {
    state.adminById.status = payload;
  },
  SET_ADMIN_BY_ID(state, payload) {
    state.adminById.data.push(payload);
  },
};

const actions = {
  /**
   * Retrieves a list of admins based on the provided payload.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} state - The Vuex state object.
   * @param {Object} payload - The payload containing the query parameters.
   * @param {Object} payload.query - The query parameters.
   * @param {string} payload.query.paymentMethodId - The ID of the payment method to filter by.
   * @return {Promise<void>}
   */
  async getAdmins({ commit, state }, payload) {
    const status = state.admins.status;
    commit("SET_ADMIN_STATUS", "loading");
    const response = await Requests.Admin.GetAll(payload);
    if (response.message === "OK") {
      commit("SET_ADMINS", {
        items: response.data.items.map((item) => ({
          ...item,
          page: payload.query.page || 1,
        })),
        count: response.data.count,
      });
      if (status === "unitiliazed")
        commit("SET_ALL_ADMINS", {
          items: response.data.items.map((item) => ({
            ...item,
            page: payload.query.page || 1,
          })),
          count: response.data.length,
        });
    }
    commit("SET_ADMIN_STATUS", "success");
    return response.message;
  },
  /**
   * Creates an admin by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the admin data.
   * @param {string} payload.paymentMethodId - The ID of the payment method.
   * @param {string} payload.adminRate - The admin rate.
   * @return {Promise<void>} - A promise that resolves when the creation is complete.
   */
  async createAdmin({ state, commit }, payload) {
    state.createStatus = "loading";
    try {
      const response = await Requests.Admin.Create(payload);
      state.createStatus = "success";
      if (response.message === "OK")
        commit("SET_CREATE_ADMIN", {
          id: response.data,
          paymentMethodId: payload.paymentMethodId,
          adminRate: payload.adminRate,
          isActive: true,
          page: 1,
        });
      else state.createStatus = "error";
    } catch {
      state.createStatus = "error";
    }
  },
  /**
   * Updates an admin by making a request to the server.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the admin data to update.
   * @param {string} payload.paymentMethodId - The ID of the payment method.
   * @param {string} payload.adminRate - The admin rate.
   * @param {boolean} payload.isActive - Whether the admin is active or not.
   * @return {Promise<void>} - A promise that resolves when the update is complete.
   */
  async updateAdmin({ state, commit }, payload) {
    state.updateStatus = "loading";
    try {
      const response = await Requests.Admin.Update(payload, {
        params: { id: payload.id },
      });
      if (response.message === "OK") {
        commit("SET_UPDATE_ADMIN", payload);
        state.updateStatus = "success";
      } else {
        state.updateStatus = "error";
      }
    } catch {
      state.updateStatus = "error";
    }
  },
  /**
   * Removes an admin from the state and updates the delete status.
   *
   * @param {Object} context - The Vuex action context.
   * @param {Object} payload - The payload containing the admin data.
   * @param {number} payload.id - The ID of the admin to be removed.
   * @returns {Promise<void>} A promise that resolves when the admin is successfully removed.
   */
  removeAdmin({ state }, { id }) {
    state.deleteStatus = "loading";

    return Requests.Admin.Delete({ params: { id } })
      .then((response) => {
        state.deleteStatus = response.message === "OK" ? "success" : "error";
        return response;
      })
      .catch(() => {
        state.deleteStatus = "error";
        return { message: "ERROR" };
      });
  },
  /**
   * Retrieves an admin by their ID and updates the admin by ID status in the Vuex store.
   *
   * @param {Object} commit - The Vuex commit function.
   * @param {Object} id - The ID of the admin to retrieve.
   * @return {Promise} A promise that resolves when the admin is successfully retrieved and the status is updated.
   */
  getAdminById({ commit, state }, { id }) {
    // check if admin already exists in the state;
    if (state.adminById.data.find((admin) => admin.id === id)) return;
    commit("SET_ADMIN_BY_ID_STATUS", "loading");
    return Requests.Admin.GetById({ params: { id } })
      .then((response) => {
        commit("SET_ADMIN_BY_ID", response.data);
        commit("SET_ADMIN_BY_ID_STATUS", "success");
      })
      .catch(() => {
        commit("SET_ADMIN_BY_ID_STATUS", "error");
      });
  },
};

export default { state, getters, mutations, actions };
